module.exports = __webpack_public_path__ + "d5e9cea7c18c019ff83cbb6070d338e8.svg";